"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const defaultGetIsTokenEditable = () => true;
exports.default = defaultGetIsTokenEditable;
